import React, { useState } from "react";
import {
  Button,
  Input,
  Modal,
  Form,
  Tooltip,
  message,
  Spin,
  Row,
  Col,
  Checkbox,
  Select,
} from "antd";
import IntlMessages from "../util/IntlMessages";
import ds from "../Services/DataServices";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useStore, useDispatch } from "react-redux";
import { loadData } from "../appRedux/actions/Setting";
import { IntlProvider } from "react-intl";
import { BEHAVIOUR_TYPE } from "../Services/DataServices";
import {
  notAllowMsgCheck,
  isEmptyObject,
  getDecryptID,
  loadGroupAttribs,
} from "../appRedux/actions";
import { loadSellAttributeData } from "../appRedux/actions/Sell";
import { TableName } from "../constants/TableName";
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 },
  },
};

const AddSellAttributes = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const getSellAttributeGroupsData = useSelector(
    ({ commonConfigs }) => commonConfigs.getSellAttributeGroupsData
  );
  const [visible, setVisible] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [getIsShow, setIsShow] = React.useState(false);
  const [getIsActive, setIsActive] = React.useState(false);
  const [getIsLoading, setIsLoading] = React.useState(false);
  const [getSellAttributeData, setSellAttributeData] = React.useState([]);
  // const [getSellAttributeGroupsData, setSellAttributeGroupsData] =
  //   React.useState([]);
  const methodType = props.behavior;
  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setVisible(false);
      setConfirmLoading(false);
    }, 2000);
  };
  const handleCancel = () => {
    setVisible(false);
  };
  const onFinishFailed = (errorInfo) => {
    message.error(<IntlMessages id="sell.settings.failedtoloaddata" />);
  };
  const isloadAttributeData = useSelector(
    ({ Sell }) => Sell.isloadAttributeData
  );

  React.useEffect(() => {
    const attrData = props.data ? props.data : [];
    form.setFieldsValue({
      Title: attrData.title,
      DisplaySeqNo: attrData.displaySeqNo,
      SellAttributeGroupID: getDecryptID(attrData.sellAttributeGroupID),
    });
    setIsActive(attrData.isActive);
    setSellAttributeData(attrData);
  }, [props.data]);

  const onFinish = async (values) => {
    setVisible(false);
    setIsShow(true);
    let body = {
      BehaviorName: methodType ? parseInt(methodType) : 1,
      SellAttributeID:
        getSellAttributeData && getSellAttributeData.sellAttributeID
          ? getSellAttributeData.sellAttributeID
          : "",
      SellAttributeGroupID: values.SellAttributeGroupID
        ? parseInt(values.SellAttributeGroupID)
        : 1,
      Title: values.Title,
      DisplaySeqNo: parseInt(values.DisplaySeqNo),
      IsActive: getIsActive,
    };
    const behavior =
      methodType && methodType == "3"
        ? BEHAVIOUR_TYPE.PUT
        : BEHAVIOUR_TYPE.POST;
    postSellAttribute(body, behavior);
    form.resetFields();
    setTimeout(() => {
      setIsShow(false);
    }, 2000);
  };
  async function postSellAttribute(body, behavior) {
    const resp = ds.addUpdateDeleteSellAttribute(body, behavior);
    await resp
      .then((res) => {
        setIsLoading(false);
        if (res) {
          if (res.data) {
            let message = res.data.data;
            dispatch(loadSellAttributeData(message));
            message.success(message);
          }
        } else {
          message.error(res.data.data);
        }
      })
      .catch((e) => {
        setIsLoading(false);
        notAllowMsgCheck(e);
      });
  }

  const showModal = () => {
    setVisible(true);
  };
  const valideDuplicateName = (rule, value, callback) => {
    let body = {
      TableName: TableName.SellAttributes,
      SearchValue: value,
      ID:
        getSellAttributeData && getSellAttributeData.sellAttributeID
          ? getSellAttributeData.sellAttributeID
          : `0&&_bd98-6131-47dd-8ac8-4bd1856d2a60`,
    };
    const getIsExist = ds.checkIsNameExist(body, BEHAVIOUR_TYPE.POST);
    getIsExist
      .then((response) => {
        if (response) {
          //setIsOrderNumberExist(response);
          callback("This Sell Attribute name exists. Add a different one.");
        } else {
          callback();
        }
      })
      .catch((e) => {});
  };

  return (
    <div>
      {getIsShow ? (
        <div style={{ marginRight: "660px" }}>
          <Spin
            tip={<IntlMessages id="sell.settings.addsellattribute" />}
            spinning={getIsShow}
            size="large"
          ></Spin>
        </div>
      ) : (
        <div className="text-right AddSellAttributes-btn">
          {methodType && methodType == "3" ? (
            <span>
              <a onClick={showModal} className="pen-edit">
                <i className="icon icon-edit" />
              </a>
            </span>
          ) : (
            <Button
              className="dk-btn-add"
              type="primary"
              onClick={showModal}
              size="large"
            >
              <IntlMessages id="sell.settings.addsellattributes" />
            </Button>
          )}

          <Modal className="NewSellAttribute-Modal"
            title={<IntlMessages id={`${methodType && methodType == "3" ?  "sell.settings.editsellattribute"  :  "sell.settings.newsellattribute"}`}  />}
            visible={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            centered={true}
            width={"402px"}
            footer={
              <>
              <Button form="SellAttribute" className="dk-btn-add" type="primary" htmlType="submit" >
                    <IntlMessages id="sell.settings.addsellattributes" />
                  </Button>
                  </>
            }
          >
            <Form className="col-pad-label"
              {...formItemLayout}
              form={form}
              name="SellAttribute"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
            >
              <Form.Item
                className="ant-form-item-label-custom ant-form-margin-right"
                name="Title"
                label={
                  <span>
                   
                      <IntlMessages id="sell.settings.attributetitle" />
                  
                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please enter attribute name",
                    whitespace: true,
                  },
                  {
                    validator: valideDuplicateName,
                  },
                ]}
              >
                <Input placeholder="Sell Attribute Name" />
              </Form.Item>

              <Form.Item
                className="ant-form-item-label-custom ant-form-margin-right"
                name="DisplaySeqNo"
                label={
                  <span>
                 
                      <IntlMessages id="sell.settings.attributedisplayseqno" />
                   
                  </span>
                }
              >
                <Input placeholder="Enter display seq no" />
              </Form.Item>

              <Form.Item
                className="ant-form-item-label-custom ant-form-margin-right"
                name="SellAttributeGroupID"
                label={<IntlMessages id="sell.settings.sellattributegroup" />}
              >
                <Select
                  placeholder={
                    <IntlMessages id="sell.settings.sellattributegroup" />
                  }
                  showSearch
                  optionFilterProp="children"
                >
                  {getSellAttributeGroupsData &&
                    getSellAttributeGroupsData.map((e, key) => {
                      return (
                        <option
                          key={key}
                          value={getDecryptID(e.sellAttributeGroupID)}
                        >
                          {e.title}
                        </option>
                      );
                    })}
                </Select>
              </Form.Item>

              <Form.Item>
                <Checkbox checked={getIsActive} onChange={() => setIsActive(!getIsActive)} >
                  <p className="mb-0"> <IntlMessages id="sell.settings.attributeactive" /></p>
                </Checkbox>
              </Form.Item>

             
            </Form>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default AddSellAttributes;
